import {
  QA_NAME_GRETA_AI_CHAT_CHAT_MENU_COPY_ID,
  QA_NAME_GRETA_AI_CHAT_CHAT_MENU_DELETE,
  QA_NAME_GRETA_AI_CHAT_CHAT_MENU_RENAME,
} from '../GretaAIChat.constants'

import CopyIcon from '../../../icons/copy.svg'
import DeleteIcon from '../../../icons/delete.svg'
import EditIcon from '../../../icons/edit.svg'

export function getGretaAIChatChatMenuItems({
  t,
  onCopyId,
  onDelete,
  onRename,
}) {
  return [
    {
      Icon: EditIcon,
      qaName: QA_NAME_GRETA_AI_CHAT_CHAT_MENU_RENAME,
      text: t('Greta.RenameChatActionKey'),
      onClick: onRename,
    },
    {
      Icon: CopyIcon,
      qaName: QA_NAME_GRETA_AI_CHAT_CHAT_MENU_COPY_ID,
      text: t('Greta.CopyChatIdKey'),
      onClick: onCopyId,
    },
    {
      Icon: DeleteIcon,
      qaName: QA_NAME_GRETA_AI_CHAT_CHAT_MENU_DELETE,
      text: t('Greta.DeleteChatActionKey'),
      onClick: onDelete,
    },
  ]
}
